// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"648f8fc3","264":"71aa011a","477":"8d0348a1","584":"a29c659a","658":"1776b2df","775":"ff01e9b9","805":"3fee3e19","937":"bf0e7479","947":"d86af0c8"}[chunkId] + ".chunk.css";
};